import * as React from "react"
import { IUserData } from "../interface/IUserData"

interface ICtx {
	users: IUserData | undefined
	setUsers: React.Dispatch<React.SetStateAction<IUserData | undefined>>
}

const InitialCtxState: ICtx = {
	users: undefined,
	setUsers: () => {},
}

export const Context = React.createContext<ICtx>(InitialCtxState)

const CtxProvider: React.FC<{
	children: React.ReactNode
}> = ({ children }) => {
	const [users, setUsers] = React.useState<ICtx["users"]>(
		InitialCtxState.users
	)

	const contextValue = React.useMemo(
		() => ({
			users,
			setUsers,
		}),
		[users, setUsers]
	)

	return <Context.Provider value={contextValue}>{children}</Context.Provider>
}

export const UserCtxProvider = CtxProvider
